var map = {
	"./pt-BR/blog.js": 37170,
	"./pt-BR/branding.js": 72733,
	"./pt-BR/candidates.js": 75816,
	"./pt-BR/channelAccounts.js": 33855,
	"./pt-BR/cms_categories.js": 10432,
	"./pt-BR/cms_products.js": 4884,
	"./pt-BR/commercial_models.js": 62337,
	"./pt-BR/crmDashboards.js": 74937,
	"./pt-BR/dossierLibrary.js": 22174,
	"./pt-BR/leads.js": 67819,
	"./pt-BR/login.js": 80397,
	"./pt-BR/offer_types.js": 76092,
	"./pt-BR/offers.js": 57789,
	"./pt-BR/opportunities.js": 90157,
	"./pt-BR/opportunitiesBoards.js": 17968,
	"./pt-BR/pages.js": 70180,
	"./pt-BR/permissions.js": 78928,
	"./pt-BR/roles.js": 45097,
	"./pt-BR/scan_monitoring.js": 43332,
	"./pt-BR/scanner_settings.js": 75992,
	"./pt-BR/searchList.js": 47518,
	"./pt-BR/service_types.js": 68065,
	"./pt-BR/services.js": 63614,
	"./pt-BR/tags.js": 74495
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35615;